export function openLinkByAnchor(
  url: string,
  options?: { target: HTMLAnchorElement['target']; rel: HTMLAnchorElement['rel'] },
) {
  const { target = '_blank', rel = 'noopener noreferrer' } = options || {};
  console.log('url:', url);
  const link = document.createElement('a');
  link.href = url || '';
  link.target = target;
  link.rel = rel;
  link.click();
}
